import { render, staticRenderFns } from "./OpenCombos.vue?vue&type=template&id=a88361fc&"
import script from "./OpenCombos.vue?vue&type=script&lang=js&"
export * from "./OpenCombos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports